import React, { Component } from 'react';
import AutomatTableRetrieval from '../tableWrappers/AutomatTableRetrieval';
import UserEditableContainer from '../../containers/users/UserEditableContainer';
import SubmitButton from '../blueprintWrappers/SubmitButton';
import StandardOverlay from '../blueprintWrappers/StandardOverlay';

const columns = [
	{
		'name': 'firstName',
		'title': 'First Name'
	},
	{
		'name': 'lastName',
		'title': 'Last Name'
	},
	{
		'name': 'userName',
		'title': 'User Name'
	},
	{
		'name': 'dispatchUserType',
		'title': 'Dispatch User Type'
	},
	{
		'name': 'active',
		'title': 'Active'
	}
]

class Users extends Component {
	render() {
		return <div className = 'users'>
			<div className="pt-card">
				<h1>Users</h1>
				<hr/>
				{this.table()}
				{this.addNewUser()}
			</div>
		</div>;
	}

	table = () => {
		const baseProps = {
			query: 'Users.GetCurrentUsers',
			params: {},
			columns: columns,
			tableRowComponent: this.userEditable,
			hiddenColumns: ['key'],
			pageSize: 10,
			columnFilter: true
		}
		const initProps = Object.assign(baseProps, this.props.tableProps);
		return <AutomatTableRetrieval 
			{...initProps}
		/>
	}

	addNewUser = () => {
		const { newUser, toggleNewUser, cancelNewUser } = this.props;
		return <div className = 'users_new_button'>
			<SubmitButton 
				display = 'Create New User'
				onClick = { toggleNewUser }
			/>
			<StandardOverlay 
				isOpen = { newUser }
			>
				<UserEditableContainer
					cancelEditable = { cancelNewUser }
				/>
			</StandardOverlay>
		</div>
	}

	userEditable = ({row}) => {
		const { cancelEditable } = this.props;
		const baseAttributes = row;
		const props = {cancelEditable, baseAttributes};
		return <UserEditableContainer 
			{...props}
		/>
	}
}

export default Users;


// WEBPACK FOOTER //
// ./src/components/users/Users.jsx